/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/widget_ios'
export default icon
